import { capitalizeFirstLetter } from './capitalize-first-letter';

export function objectiveQUestion(quizOptions: any[], quizAnswers: any[]) {
  return quizOptions.map((option) => {
    const some = quizAnswers.some(({ quizAnswerOptions }) => quizAnswerOptions.some((quizAnswerd) => quizAnswerd.fkQuizOptions === option.cdQuizOptions));

    return {
      value: capitalizeFirstLetter(option.vlOption.toLowerCase()),
      initChecked: some,
    };
  });
}
